import { render, staticRenderFns } from "./addRiskDevices.vue?vue&type=template&id=27fd39d1&scoped=true"
import script from "./addRiskDevices.vue?vue&type=script&lang=js"
export * from "./addRiskDevices.vue?vue&type=script&lang=js"
import style0 from "./addRiskDevices.vue?vue&type=style&index=0&id=27fd39d1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fd39d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27fd39d1')) {
      api.createRecord('27fd39d1', component.options)
    } else {
      api.reload('27fd39d1', component.options)
    }
    module.hot.accept("./addRiskDevices.vue?vue&type=template&id=27fd39d1&scoped=true", function () {
      api.rerender('27fd39d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/security/components/addRiskDevices.vue"
export default component.exports